export default "__VITE_ASSET__Ixr13dDL__"